import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend
} from 'recharts';

// Corrected data structure with unified X-axis
const data2 = [
  { quarter: 'Q1', inherent: 18, residual: 12, future: 6 },
  { quarter: 'Q2', inherent: 19, residual: 11, future: 7 },
  { quarter: 'Q3', inherent: 21, residual: 13, future: 5 },
  { quarter: 'Q4', inherent: 23, residual: 10, future: 3 }
];

const getLastFourQuarters = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  const currentQuarter = Math.floor(currentMonth / 3) + 1;

  let quarters = [];

  for (let i = 3; i >= 0; i--) {
    let quarter = currentQuarter - i;
    let year = currentYear;

    if (quarter <= 0) {
      quarter += 4;
      year -= 1;
    }

    quarters.push(`Q${quarter} ${year}`);
  }

  return quarters;
};

// Get the correct quarter labels
const quarterLabels = getLastFourQuarters();

// Fix backend data to replace "Current" with the actual latest quarter
const fixBackendData = (backendData) => {
  return backendData && backendData.map((item, index) => ({
    ...item,
    quarter: item.quarter === "Current" ? quarterLabels[3] : quarterLabels[index] // Replace "Current" with correct label
  }));
};




// Custom dot for the points
const CustomDot = (props) => {
  const { cx, cy, stroke, value } = props;
  return (
    <g>
      <circle cx={cx} cy={cy} r={8} stroke={stroke} strokeWidth={2} fill={stroke} />
      <text x={cx} y={cy - 10} textAnchor="middle" fill="#000">
        {value}
      </text>
    </g>
  );
};

const RiskLineChart = ({ height, data }) => {
  //////console.log(data);
  const fixedData = fixBackendData(data);
  //console.log("fixedData", fixedData)

  const hasAnyValue = fixedData?.some(d =>
    (d.inherent ?? 0) !== 0 ||
    (d.residual ?? 0) !== 0 ||
    (d.future ?? 0) !== 0
  );

  const allZero =
    fixedData?.length > 0 &&
    fixedData?.every(d => (d.inherent ?? 0) === 0 && (d.residual ?? 0) === 0 && (d.future ?? 0) === 0);


  let dataMax = 0;

  if (fixedData) {
    dataMax = Math.max(
      0,
      ...fixedData?.map(d => Math.max(d.inherent || 0, d.residual || 0, d.future || 0))
    );
  }


  return (
    <ResponsiveContainer width="100%" height={height} className="p-2">
      <LineChart data={fixedData} margin={{ top: 40, right: 20, bottom: 20, left: 10 }}>
        <Legend align="center" wrapperStyle={{ marginBottom: 0 }} iconType="circle" />

        <XAxis dataKey="quarter" dy={10} interval={0} />
        <YAxis
          hide
          domain={[0, Math.max(1, dataMax)]}   // key line: prevents domain [0,0]
          allowDecimals={false}
        />
        <Tooltip />

        <Line
          type="monotone"
          dataKey="inherent"
          stroke="#F07167"
          strokeWidth={2}
          dot={allZero ? false : <CustomDot />}
          activeDot={allZero ? false : { r: 8 }}
          isAnimationActive={false}
        />
        <Line
          type="monotone"
          dataKey="residual"
          stroke="#FED4AE"
          strokeWidth={2}
          dot={allZero ? false : <CustomDot />}
          activeDot={allZero ? false : { r: 8 }}
          isAnimationActive={false}
        />
        <Line
          type="monotone"
          dataKey="future"
          stroke="#05769D"
          strokeWidth={2}
          dot={allZero ? false : <CustomDot />}
          activeDot={allZero ? false : { r: 8 }}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RiskLineChart;
